import { render } from "./AddArtwork.vue?vue&type=template&id=100982ea&scoped=true"
import script from "./AddArtwork.vue?vue&type=script&lang=js"
export * from "./AddArtwork.vue?vue&type=script&lang=js"

import "./AddArtwork.vue?vue&type=style&index=0&id=100982ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-100982ea"]])

export default __exports__